import { Flex, SimpleGrid } from "@chakra-ui/react";
import { Marker } from "@airhelp/icons";
import type { Airport } from "@airhelp/react";
import { AutocompleteInput } from "../../AutocompleteInput";
import type { ConnectingAirport } from "../../AutocompleteForm.d";
import { AddConnectionButton } from "./AddConnectionButton";
import { RemoveConnectionButton } from "./RemoveConnectionButton";

interface ConnectingAirportInputProps {
  disabledAirports: Airport[];
  onRemove: (id: string) => void;
  setConnection: (airport: Airport, id: string) => void;
  addConnection: () => void;
  showAddConnectionButton: boolean;
  id: string;
  index?: number;
}

interface ConnectingAirportInputsProps extends Omit<ConnectingAirportInputProps, "id"> {
  connections: Array<ConnectingAirport | Pick<ConnectingAirport, "id">>;
}

const ConnectingAirportInput = ({
  disabledAirports,
  onRemove,
  setConnection,
  addConnection,
  showAddConnectionButton,
  id,
  index
}: ConnectingAirportInputProps) => {
  const placeholderText = "Transit airport";
  const placeholder = index === 0 ? placeholderText : `${placeholderText} ${index + 1}`;

  return (
    <SimpleGrid
      templateColumns={{ base: "85% 15%", sm: "90% 10%" }}
    >
      <Flex>
        <AutocompleteInput
          placeholder={placeholder}
          setAirportSelected={(airport) => setConnection(airport, id)}
          instanceId={`connection_airport_${id}`}
          disabledAirports={disabledAirports}
          icon={<Marker boxSize={6} />}
        />
      </Flex>
      <Flex
        color="primary.500"
        fontSize="xl"
        alignSelf="center"
        justifySelf="center"
      >
        {index === 0 ? (
          (showAddConnectionButton &&<AddConnectionButton onClick={addConnection} />)
        ) : (
          <RemoveConnectionButton onClick={() => onRemove(id)} />
        )}
      </Flex>

    </SimpleGrid>
  );
};

export const ConnectingAirportInputs = ({
  disabledAirports,
  connections,
  onRemove,
  setConnection,
  addConnection,
  showAddConnectionButton,
}: ConnectingAirportInputsProps) => <> {
    connections.map(({ id }, index) => (
      <ConnectingAirportInput
        key={id}
        id={id}
        index={index}
        onRemove={onRemove}
        setConnection={setConnection}
        addConnection={addConnection}
        showAddConnectionButton={showAddConnectionButton}
        disabledAirports={disabledAirports}
      />
    ))
  }</>
